var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "assignee-info col-md-12 flex mt-4" }, [
    _c("div", { staticClass: "col-md-3 flex flex-align-c" }, [
      _c("div", { staticClass: "flex flex-column" }, [
        _c("span", { staticClass: "assignee-title" }, [
          _vm._v("Claim created date")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "assignee-content" }, [
          _vm._v(_vm._s(_vm.claimById.date))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-3 flex flex-align-c" }, [
      _c("div", { staticClass: "flex flex-column" }, [
        _c("span", { staticClass: "assignee-title" }, [
          _vm._v("Claim created by")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "assignee-content" }, [
          _vm._v(_vm._s(_vm.claimById.created_by.username))
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "col-md-6 flex assigned-to flex-align-c flex-justify-end"
      },
      [
        _c("div", { staticClass: "flex flex-column" }, [
          _c("span", { staticClass: "assignee-title" }),
          _vm._v(" "),
          _vm.$_can("claims.assign")
            ? _c(
                "div",
                { staticClass: "select" },
                [
                  _c("label", { staticClass: "assignee-title pl-3" }, [
                    _vm._v("Assigned to")
                  ]),
                  _vm._v(" "),
                  _vm.claimById.cluster_user
                    ? _c("simple-select", {
                        staticClass: "assignee-content",
                        attrs: {
                          placeholder: _vm.claimById.cluster_user.username,
                          options: _vm.claimsUsers,
                          label: "username"
                        },
                        on: { input: _vm.claimUpdate },
                        model: {
                          value: _vm.claim.cluster_user_id,
                          callback: function($$v) {
                            _vm.$set(_vm.claim, "cluster_user_id", $$v)
                          },
                          expression: "claim.cluster_user_id"
                        }
                      })
                    : _c("simple-select", {
                        staticClass: "assignee-content",
                        attrs: {
                          placeholder: "Unassigned",
                          options: _vm.claimsUsers,
                          label: "username"
                        },
                        on: { input: _vm.claimUpdate },
                        model: {
                          value: _vm.claim.cluster_user_id,
                          callback: function($$v) {
                            _vm.$set(_vm.claim, "cluster_user_id", $$v)
                          },
                          expression: "claim.cluster_user_id"
                        }
                      })
                ],
                1
              )
            : _c("div", { staticClass: "flex flex-column" }, [
                _c("label", { staticClass: "assignee-title no-permission" }, [
                  _vm._v("Assigned to")
                ]),
                _vm._v(" "),
                _vm.claimById.cluster_user
                  ? _c("span", [
                      _vm._v(_vm._s(_vm.claimById.cluster_user.username))
                    ])
                  : _c("span", [_vm._v("-")])
              ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e743a40", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e743a40","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/claims/ClaimAssigneInfo.vue
// module id = null
// module chunks = 